export default __webpack_public_path__ + "static/media/lost.c88ea20f.svg";